module.exports = __webpack_public_path__ + "img/25.1fe18ba1.png";